export default function DaltonismTest() {
  const selectorTestDaltnonism = document.querySelector('.daltonism_test');
  if (selectorTestDaltnonism) {
    var triangle1 = document.getElementById('agreed-2');
    var circle4 = document.getElementById('agreed-1');
    var triangle2 = document.getElementById('agreed-5');
    var triangle3 = document.getElementById('agreed-9');
    var triangle4 = document.getElementById('agreed-13');
    var circle1 = document.getElementById('agreed-7');
    var circle2 = document.getElementById('agreed-11');
    var circle3 = document.getElementById('agreed-15');
    var kvadrat = document.getElementById('agreed-3');
    var kvadrat1 = document.getElementById('agreed-6');
    var kvadrat2 = document.getElementById('agreed-10');
    var kvadrat3 = document.getElementById('agreed-14');
    var onlyColor = document.getElementById('agreed-4');
    var onlyColor1 = document.getElementById('agreed-8');
    var onlyColor2 = document.getElementById('agreed-16');
    var twoTriagle = document.getElementById('agreed-12');
    const inputContainer = selectorTestDaltnonism.querySelector('.inputContainer');
    const formCheckBOx1 = selectorTestDaltnonism.querySelector('.container_checkbox.first');
    const formCheckBOx2 = selectorTestDaltnonism.querySelector('.container_checkbox.second');
    const formCheckBOx3 = selectorTestDaltnonism.querySelector('.container_checkbox.third');
    const formCheckBOx4 = selectorTestDaltnonism.querySelector('.container_checkbox.fourth');
    var resultTestDaltonic = selectorTestDaltnonism.querySelector('.result_test_daltonic');
    var resultTextDaltonic = selectorTestDaltnonism.querySelector('.result_text_daltonic');
    var blockGamesEyes = selectorTestDaltnonism.querySelector('.block_games_eyes');
    const answer = document.getElementById('answer');
    const formTestDaltonic = document.getElementById('form');
    var trueAnswer = [96, 9, 13, 5, 9, 136, 30, 36, 9];
    var userAnswer = [];
    var ball = 0;
    var idInput = 1;
    var idForm = 1;
    answer.id = "answer" + idInput;
    formTestDaltonic.id = "form" + idForm;


    resultTextDaltonic.style.cssText += 'font-weight:700;border-radius:7px;padding:10px 7px;border:solid 2px;border-color:orange;';


    let slideIndex = 1;
    showSlides(slideIndex);

    const inputElement = inputContainer.querySelector('.question_input');
    const inputBtn = inputContainer.querySelector('.blue-btn');

    // переход на следующий этап при нажатии таба в текстовом инпуте
    if (inputElement) {
      inputElement.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
          if (inputBtn) {
            inputBtn.click();
          }
        }
      });
    }

    let next = selectorTestDaltnonism.querySelector('.block_games_eyes').querySelectorAll('.blue-btn');

    next.forEach((el) => {
      el.addEventListener("click", function () {
        if (slideIndex != 13) {
          showSlides(slideIndex += 1);
        }

        idForm += 1;
        formTestDaltonic.id = "form" + idForm;

        if (formTestDaltonic.id === 'form3' || formTestDaltonic.id === 'form5' || formTestDaltonic.id === 'form10' || formTestDaltonic.id === 'form13') {
          inputContainer.style.display = 'none';
          if (formTestDaltonic.id === 'form3') {
            formCheckBOx1.style.display = 'block';
          }
          if (formTestDaltonic.id === 'form5') {
            formCheckBOx2.style.display = 'block';
          }
          if (formTestDaltonic.id === 'form10') {
            formCheckBOx3.style.display = 'block';
          }
          if (formTestDaltonic.id === 'form13') {
            formCheckBOx4.style.display = 'block';
          }
        }
        else {
          inputContainer.style.display = 'block';
          formCheckBOx1.style.display = 'none';
          formCheckBOx2.style.display = 'none';
          formCheckBOx3.style.display = 'none';
          formCheckBOx4.style.display = 'none';
          idInput += 1;
          answer.id = "answer" + idInput;
          userAnswer.push(answer.value);
          answer.value = '';
        }
        if (formTestDaltonic.id === 'form4') {
          if (triangle1.checked && !circle4.checked && !kvadrat.checked && !onlyColor.checked) {
            ball += 1;
          }
        }
        if (formTestDaltonic.id === 'form6') {
          if (triangle2.checked && circle1.checked && !kvadrat1.checked && !onlyColor1.checked) {
            ball += 1;
          }
        }
        if (formTestDaltonic.id === 'form11') {
          if (triangle3.checked && circle2.checked && !kvadrat2.checked && !twoTriagle.checked) {
            ball += 1;
          }
        }

        //переход на результат
        if (formTestDaltonic.id === 'form14') {
          if (triangle4.checked && circle3.checked && !kvadrat3.checked && !onlyColor2.checked) {
            ball += 1;
          }
          resultTestDaltonic.style.display = 'block';
          blockGamesEyes.style.display = 'none';

          for (var i = 0; i < 9; i++) { // Цикл по всем эле­мен­там
            if (trueAnswer[i] == userAnswer[i]) {
              ball += 1;
            }
          }

          if (ball === 0) {
            resultTextDaltonic.innerHTML = 'У Вас большие проблемы с цветовостриятием. Вы не ответили ни на один вопрос из 13. Советуем в ближайшее время посетить врача-офтальмолога.';
          }
          if (ball >= 0 && ball <= 4) {
            resultTextDaltonic.innerHTML = 'У Вас большие проблемы с цветовостриятием. Вы правильно ответили  лишь на ' + ball + ' из 13. Советуем в ближайшее время посетить врача-офтальмолога!';
          }
          if (ball >= 5 && ball <= 12) {
            resultTextDaltonic.innerHTML = 'У Вас есть проблемы с цветовостриятием. Вы правильно ответили на ' + ball + ' из 13. Советуем в ближайшее время посетить врача-офтальмолога!';
          }
          if (ball === 13) {
            resultTextDaltonic.innerHTML = 'У Вас отличное цветовосприятие. Вы правильно ответили на ' + ball + ' из 13. Однако компьютерное тестирование может дать лишь предварительную оценку.';
          }
        }
        //
      });
    });

    function currentSlide(n) {
      showSlides(slideIndex = n);
    }


    function showSlides(n) {
      let slides = selectorTestDaltnonism.getElementsByClassName("guess_game__slide");
      if (n > slides.length) {
        slideIndex = 1;
      }
      if (n < 1) {
        slideIndex = slides.length;
      }

      for (let slide of slides) {
        slide.style.display = "none";
      }
      slides[slideIndex - 1].style.display = "block";
    }

  }
}
